import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { style } from './zui-shell-apps-item-css.js';
import { ZuiShellBase } from './zui-shell-base';
import type { PropertyValues } from 'lit';

/**
 * Child element of `<zui-shell-apps>` that renders into a link for each product the user has access to.
 *
 * @element zui-shell-apps-item
 */
export class ZuiShellAppsItem extends ZuiShellBase {
  /**
   * Name of the application
   */
  @property({ type: String, attribute: 'name' }) name = '';

  /**
   * (optional): Description of the application
   */
  @property({ type: String, attribute: 'description' }) description = '';

  /**
   * URL to the application
   */
  @property({ type: String, attribute: 'url' }) url = '';

  /**
   * (optional): Specify where to open the link; default opens in a new tab
   */
  @property({ type: String, attribute: 'target' }) target = '_blank';

  static get styles() {
    const result = [super.styles, style];

    return result;
  }

  constructor() {
    super();

    this._observeNavCollapseChange = true;
  }

  connectedCallback() {
    super.connectedCallback();
  }

  updated(changedProps: PropertyValues) {
    super.updated(changedProps);
  }

  protected onScreenBreakpointChange() {
    super.onScreenBreakpointChange();
  }

  protected onNavCollapseChange() {
    super.onNavCollapseChange();
  }

  render() {
    return html`
      <div class="app-container">
        <a class="app-link" href="${this.url}" target="${this.target}" rel="noopener">
          <div class="name">${this.name}</div>
          ${this.description ? html` <div class="description">${this.description}</div> ` : ''}
        </a>
      </div>
    `;
  }
}

window.customElements.define('zui-shell-apps-item', ZuiShellAppsItem);

declare global {
  interface HTMLElementTagNameMap {
    'zui-shell-apps-item': ZuiShellAppsItem;
  }
}
